import Vue from 'vue';
import Router from 'vue-router';
import Login from '../components/pages/security/Login';
import ResetPassword from '../components/pages/security/ResetPassword';
import Dashboard from '../components/pages/dashboard/Dashboard';
import NotFound from '../components/pages/error/NotFound';
import EnedisCase from '../components/pages/enedis-case/EnedisCase';
import Statistics from '../components/pages/statistics/Statistics';
import Gaps from '../components/pages/gaps/Gaps';
import CaseManagers from '../components/pages/case-managers/CaseManagers';
import Profile from '../components/pages/profile/Profile';
import Admin from '../components/pages/admin/Admin';
import AuthService from '../services/AuthService';
import Store from '../store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    { path: '*', component: NotFound },
    {
      path: '/',
      name: 'login',
      component: Login,
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile,
    },
    {
      path: '/logout',
      name: 'logout',
    },
    {
      path: '/agents',
      name: 'admin',
      component: Admin,
    },
    {
      path: '/reset/password/:token',
      name: 'resetPassword',
      component: ResetPassword,
    },
    {
      path: '/enediscase', // /:tabIndex?`, /:enedisCaseId+?
      name: 'enedisCase',
      component: EnedisCase,
      children: [
        {
          path: ':enedisCaseId+',
          name: 'case',
          component: EnedisCase,
          props: true,
        },
        {
          path: ':enedisCaseId+/:sliceId+',
          name: 'caseWithSlice',
          component: EnedisCase,
          props: true,
        },
      ],
    },
    {
      path: '/stats',
      name: 'statistics',
      component: Statistics,
    },
    {
      path: '/gaps',
      name: 'gaps',
      component: Gaps,
    },
    {
      path: '/case-managers',
      name: 'case-managers',
      component: CaseManagers,
    }
  ],
});

// Router Guard
router.beforeEach((to, from, next) => {
  const noAuthentication = ['login', 'resetPassword'];
  let safeRoute = null;

  if (to.name === 'logout') {
    Store.dispatch('logout').then(() => {}, () => {});
    safeRoute = '/';
  } else if (to.name === 'Login' && AuthService.getToken() !== null) {
    safeRoute = '/dashboard';
  } else if (noAuthentication.indexOf(to.name) === -1) {
    if (AuthService.getToken() === null) {
      safeRoute = '/';
    }
  }
  if (safeRoute === null) {
    next();
  } else {
    next(safeRoute);
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js